import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import config from '../../config';

const TEXT_TYPE = 'text';
const TEXTAREA_TYPE = 'textarea';
const PASSWORD_TYPE = 'password';

export default class InputField extends Component {
  static propTypes = {
    mainClassName: PropTypes.string,
    label: PropTypes.string,
    type: PropTypes.string,
    onChange: PropTypes.func,
  };

  static defaultProps = {
    color: config.mainColor,
    onChange: (value) => { console.log(value) },
  }

  renderTextType() {
    const { className, onChange } = this.props;

    return (
      <input
        {...this.props}
        onChange={({target: { value }}) => { onChange(value) }}
        className={className ? `input-form ${className}`: 'input-form'}
      />
    )
  }

  renderTextareaType() {
    const { className, onChange } = this.props;

    return (
      <textarea
        {...this.props}
        onChange={({target: { value }}) => { onChange(value) }}
        className={className ? `textarea-form ${className}`: 'textarea-form'}
      >
      </textarea>
    )
  }

  renderPasswordType() {
    const { className, onChange } = this.props;

    return (
      <input
        {...this.props}
        onChange={({target: { value }}) => { onChange(value) }}
        className={className ? `input-form ${className}`: 'input-form'}
      />
    )
  }

  render() {
    const {
      type,
      label,
      errorMessage,
      mainClassName,
    } = this.props;

    return (
      <div className={classNames('common-input-field', mainClassName, { 'error': errorMessage })}>
        { label && <p className="label-form">{label}</p> }
        { type === TEXT_TYPE && this.renderTextType() }
        { type === TEXTAREA_TYPE && this.renderTextareaType() }
        { type === PASSWORD_TYPE && this.renderPasswordType() }
        { errorMessage && 
          <p className="error-text">{errorMessage}</p>
        }
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/features/common/InputField.js